<style lang="scss" src='./InvalidAddressModal.scss' scoped ></style>
<template src="./InvalidAddressModal.html"></template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
export default {
  name: 'InvalidAddressModal',
  components: {},
  data() {
    return {
      show_invalid_address_message: false,
    };
  },
  watch:{},
  computed: {
    ...mapState(['invalidAddressModal']),
    ...mapGetters("Main", ['getStoreList']),
  },

  methods: {
    ...mapMutations(["setInvalidAddressModal"]),
  },
  beforeCreate() {},
  created() {
  },
  mounted() { },
  beforeDestroy() { },
};
</script>